import { Button } from "antd";
import { useDispatch } from "react-redux";
import {
  updateDisplayRoomDrawer,
  updateShowMainBookingDetailsDrawer,
  updateShowTakePaymentDrawer,
} from "../../reducer/bookingReducer";
import { updateShowAttachToPartyDrawer } from "../../reducer/nightAuditReducer";
import { updateNightAuditModalDisplay } from "../../reducer/appHeaderReducer";

const Footer = ({
  handleSave,
  drawerWidth,
  activeTab,
  handlePendinReservationInBulk,
  data,
  setActiveTab,
  selectedInvoice,
  bulkUpdateLoading,
  printSummary,
}) => {
  const dispatch = useDispatch();

  const handleExtendBooking = () => {
    dispatch(
      updateShowMainBookingDetailsDrawer({
        visible: true,
        bookingId: selectedInvoice?.[0]?.id,
        bookingType:
          activeTab === 0
            ? "upcoming"
            : activeTab === 1
            ? "ongoing"
            : "completed",
      })
    );

    setTimeout(() => {
      dispatch(updateDisplayRoomDrawer());
    }, 200);
  };

  return (
    <div
      style={{ width: drawerWidth }}
      className="py-2  border-t-[1px] z-[50] bg-[#FFF] border-[#EDF1F7] shadow-mobile-footer fixed right-0 bottom-0 flex justify-end w-full px-4"
    >
      {activeTab === 0 && (
        <div className="w-[100%] flex justify-between items-center px-3 py-2">
          {Boolean(data?.length !== 0) ? (
            <div className="flex items-center gap-[18px]">
              {" "}
              <Button
                className="border-[1px] border-[#ECF2FC] py-2 bg-[#ECF2FC] text-[#007FFF]"
                onClick={handleExtendBooking}
                loading={bulkUpdateLoading}
                disabled={selectedInvoice?.length !== 1}
              >
                Extend
              </Button>
              <Button
                className="text-white py-2 bg-[#007FFF]"
                onClick={() => handlePendinReservationInBulk("completed")}
                loading={bulkUpdateLoading}
                disabled={selectedInvoice?.length !== 1}
              >
                Check-Out
              </Button>
            </div>
          ) : (
            <div></div>
          )}

          <Button
            className="w-[130px] h-[35px]"
            disabled={data?.length > 0}
            onClick={() => setActiveTab((prev) => prev + 1)}
          >
            Next
          </Button>
        </div>
      )}

      {activeTab === 1 && (
        <div className="w-[100%] flex justify-between items-center px-3 py-2">
          {Boolean(data?.length !== 0) ? (
            <div className="flex items-center gap-[18px]">
              <Button
                className="border-[1px] border-[#F36960] py-2 bg-[#F36960] text-[#FFF]"
                onClick={() => handlePendinReservationInBulk("cancelled")}
                loading={bulkUpdateLoading}
              >
                Cancel
              </Button>{" "}
              <Button
                className="border-[1px] border-[#ECF2FC] py-2 bg-[#ECF2FC] text-[#007FFF]"
                onClick={() => handlePendinReservationInBulk("noShow")}
                loading={bulkUpdateLoading}
              >
                No-Show
              </Button>
              <Button
                className="text-white py-2 bg-[#007FFF]"
                onClick={() => handlePendinReservationInBulk("checkedIn")}
                loading={bulkUpdateLoading}
              >
                Check-in
              </Button>
            </div>
          ) : (
            <div></div>
          )}

          <Button
            className="w-[130px] h-[35px]"
            disabled={data?.length > 0}
            onClick={() => setActiveTab((prev) => prev + 1)}
          >
            Next
          </Button>
        </div>
      )}

      {activeTab === 2 && (
        <div className="w-[100%] flex justify-between items-center px-3 py-2">
          {Boolean(data?.length !== 0) ? (
            <div className="flex items-center gap-[18px]">
              {" "}
              <Button
                className="border-[1px] border-[#ECF2FC] py-2 bg-[#ECF2FC] text-[#007FFF]"
                onClick={() => dispatch(updateShowAttachToPartyDrawer(true))}
                disabled={selectedInvoice?.length !== 1}
              >
                Bill To Company
              </Button>
              <Button
                className="border-[1px] border-[#ECF2FC] py-2 bg-[#ECF2FC] text-[#007FFF]"
                onClick={() => dispatch(updateShowTakePaymentDrawer(true))}
                disabled={selectedInvoice?.length !== 1}
              >
                Record Payment
              </Button>
            </div>
          ) : (
            <div></div>
          )}
          <Button
            className="w-[130px] h-[35px]"
            disabled={data?.length > 0}
            onClick={() => dispatch(updateNightAuditModalDisplay(true))}
          >
            Complete
          </Button>
        </div>
      )}

      {activeTab === 3 && (
        <div className="w-[100%]  px-3 py-2 flex justify-between items-center">
          <Button
            className="border-[1px] w-[105px] h-[40px] border-[#ECF2FC] py-2 bg-[#ECF2FC] text-[#007FFF]"
            onClick={printSummary}
          >
            Print
          </Button>
        </div>
      )}
    </div>
  );
};

export default Footer;
